import Event from '../../core/Event';

export default class ResetPasswordRequested extends Event {
    public static type = 'ResetPasswordRequested';

    constructor(public readonly customerId: string) {
        super(ResetPasswordRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/estimations/events/ResetPasswordRequested.ts